import { type PrimitiveAtom, useAtomValue } from 'jotai'
import { focusAtom } from 'jotai-optics'
import { useMemo } from 'react'
import type { Simplify } from 'type-fest'

export function usePickAtomValue<T, K extends keyof T>(
  baseAtom: PrimitiveAtom<T>,
  keys: K[],
): Simplify<Awaited<Pick<T, K>>> {
  const keyHash = JSON.stringify(keys.slice().sort())
  const focusedAtom = useMemo(
    () => focusAtom(baseAtom, optic => optic.pick(keys)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [baseAtom, keyHash],
  )
  return useAtomValue(focusedAtom)
}
